module.exports = __webpack_public_path__ + "img/01.8c987010.webp";